var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgVisa = function SvgVisa(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H25C26.6569 0 28 1.34315 28 3V17C28 18.6569 26.6569 20 25 20H3C1.34315 20 0 18.6569 0 17V3Z",
    fill: "#0742A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0527 12.9313H11.5137L12.4763 7.13477H14.0152L13.0527 12.9313Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6322 7.27632C18.3286 7.15904 17.8472 7.02954 17.2518 7.02954C15.732 7.02954 14.6618 7.81882 14.6552 8.94725C14.6426 9.77981 15.4215 10.2422 16.004 10.5198C16.5994 10.8035 16.8018 10.9886 16.8018 11.2415C16.7958 11.6298 16.3207 11.8088 15.8776 11.8088C15.2632 11.8088 14.934 11.7165 14.4336 11.5005L14.231 11.4079L14.0156 12.7091C14.3766 12.8692 15.0416 13.0113 15.732 13.0176C17.3469 13.0176 18.3982 12.2405 18.4106 11.038C18.4168 10.3781 18.0055 9.8725 17.1188 9.45934C16.5805 9.19412 16.2509 9.01528 16.2509 8.74391C16.2572 8.49721 16.5297 8.24452 17.1373 8.24452C17.6376 8.23215 18.0052 8.34927 18.2837 8.46647L18.4229 8.52802L18.6322 7.27632Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3863 7.13477H22.5767L23.8183 12.9313H22.3933C22.3933 12.9313 22.2538 12.2652 22.2097 12.0617H20.2337L19.9107 12.9313H18.2959L20.5819 7.61571C20.7403 7.23951 21.0192 7.13477 21.3863 7.13477ZM21.2914 9.25655C21.2914 9.25655 20.8037 10.5454 20.677 10.8784H21.9562C21.8929 10.5886 21.6015 9.20106 21.6015 9.20106L21.4939 8.7016C21.4486 8.83022 21.3831 9.00705 21.339 9.12631C21.309 9.20716 21.2889 9.26155 21.2914 9.25655Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2284 7.13477L8.72118 11.0875L8.55648 10.2858C8.27783 9.36081 7.40393 8.35581 6.42871 7.8561L7.80924 12.9252H9.43669L11.8557 7.13477H10.2284V7.13477Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32174 7.13477H4.84564L4.82031 7.25189C6.75182 7.73291 8.03102 8.89241 8.55659 10.2861L8.01832 7.62202C7.9297 7.25181 7.65736 7.14698 7.32174 7.13477Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa.f8564c24.svg";
export { ForwardRef as ReactComponent };